import { render, staticRenderFns } from "./SuccessDialogPush.vue?vue&type=template&id=5ba67c3f"
import script from "./SuccessDialogPush.vue?vue&type=script&lang=js"
export * from "./SuccessDialogPush.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports